import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function challenge() {
  return (
    <section className="challenge_par challenge_chat p-100 text_white">
      <Container>
        <Row>
          <Col xs={12} md={5} lg={5} xl={5} xxl={5} className="my-auto">
            <h2>Challenges & Solutions</h2>
            <p>
              We didn’t face any significant challenges while designing and
              developing OurChat since the client has a well thought-out and
              well fleshed-out idea. They knew exactly what they wanted, which
              made our job much easier. All we had to do was execute their idea
              in the best way possible, making sure we provided a seamless user
              experience for users.
            </p>
            <p>
              This is why we created both iOS and Android apps to cater to a
              variety of different users. We also developed a web app to
              accompany it and improve accessibility, along with an admin panel
              that allows ease in managing and monitoring.
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto offset-xl-2 offset-lg-2 offset-md-1"
          >
            <div className="challenge_img text-center">
              <StaticImage
                src="../../../images/case-studies/our-chat/challenge.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={558}
                height={656}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default challenge;
